// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Hp7","col":"styles_col__3C-fF"};